import React from "react";
import type { ViewComponent } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import { registerView } from "@frui.ts/views/dist";
import BankExportDetailView from "../bankExportDetailView";
import CardReturnDetailViewModel from "../../../../viewModels/finance/bankExports/cardReturns/cardReturnDetailViewModel";

const CardReturnDetailView: ViewComponent<CardReturnDetailViewModel> = observer(({ vm }) => {
  return <BankExportDetailView vm={vm} />;
});

registerView(CardReturnDetailView, CardReturnDetailViewModel);
